import { render, staticRenderFns } from "./editEmbed.vue?vue&type=template&id=8e72737e"
import script from "./editEmbed.vue?vue&type=script&lang=js"
export * from "./editEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports